import { Box, Alert, Typography, Button, CircularProgress } from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

const CSVImportNotification = ({
  totalRecords = 100,
  successfulRecords = 77,
  failedRecords = 23,
  failureReason = "inaccessible resume links",
  onClose = () => {},
  onDownload = () => {},
  isDownloading,
}) => {
  return (
    <Alert
      severity="warning"
      icon={<InfoOutlinedIcon sx={{ color: "#F59E0B" }} />}
      sx={{
        backgroundColor: "#FFFBEB",
        border: "1px solid #FEF3C7",
        borderLeft: "5px solid #FFC107",
        borderRadius: "7px",
        color: "#92400E",
        "& .MuiAlert-icon": {
          alignItems: "flex-start",
          padding: "8px 0",
        },
        "& .MuiAlert-message": {
          padding: "8px 0",
          width: "100%",
        },
        boxShadow: "0px 1px 2px rgba(0, 0, 0, 0.05)",
      }}
    >
      <Box sx={{ width: "100%" }}>
        <Typography
          fontFamily="Outfit"
          fontWeight="700"
          color="#92400E"
        >
          CSV import completed with issues
        </Typography>
        <Typography
          variant="body2"
          color="#B45309"
          sx={{ mt: 0.5 }}
          fontFamily="Outfit"
        >
          {successfulRecords} of {totalRecords} records processed successfully.{" "}
          {failedRecords} records have {failureReason} and couldn't be analyzed
        </Typography>
        <Box sx={{ mt: 1 }}>
          <Button
            variant="outlined"
            size="small"
            startIcon={
              isDownloading ? (
                <CircularProgress size={16} sx={{ color: "#92400E" }} />
              ) : (
                <FileDownloadIcon />
              )
            }
            onClick={onDownload}
            sx={{
              textTransform: "none",
              borderColor: "#F59E0B",
              fontFamily: "Outfit",
              fontWeight: 600,
              color: "#92400E",
              backgroundColor: "white",
              "&:hover": {
                borderColor: "#D97706",
                backgroundColor: "white",
              },
            }}
            disabled={isDownloading}
          >
            {isDownloading ? "Downloading..." : "Download affected records csv"}
          </Button>
        </Box>
      </Box>
    </Alert>
  );
};

export default CSVImportNotification;
